"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _react = require('react');








// "Create a chat" opens New chat over the page with them in To. Its draft
// chat takes the right pane; closing New chat comes back to the page.
 const useEntityChat = () => {
  const [newChatEntitiesList, setNewChatEntitiesList] = _react.useState([])
  const [isDraftOpen, setIsDraftOpen] = _react.useState.call(void 0, false)
  const onCreateNewChat =
    _react.useCallback.call(void 0, (x) => setNewChatEntitiesList([x]), [setNewChatEntitiesList])
  const onCloseCreateNewChat = _react.useCallback.call(void 0, () => {
    setNewChatEntitiesList([])
    setIsDraftOpen(false)
  }, [setNewChatEntitiesList])

  return {
    newChatEntitiesList,
    isDraftOpen,
    onCreateNewChat,
    onCloseCreateNewChat,
    onDraftChange: setIsDraftOpen,
  }
}; exports.useEntityChat = useEntityChat
